import { InjectionToken } from '@angular/core';
import { ChatContextRef } from 'lib-trend-core';

/**
 * Which surface is rendering the Internal Chat UI — SPEC-2026-09-internal-chat-pwa.
 * Defined once in the primary entry point (the socket handshake needs it too) and
 * re-exported under the chat names every chat file uses. Absent = WEB_APP.
 */
export {
  CLIENT_SURFACE as CHAT_SURFACE,
  ClientSurfaceEnum as ChatClientSurfaceEnum,
} from 'lib-trend-core';

/** Firebase web configuration as each application's environment carries it. */
export interface ChatPushFirebaseConfig {
  apiKey?: string;
  authDomain?: string;
  projectId?: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId?: string;
  measurementId?: string;
  /** FCM Web Push certificate public key — empty disables web push. */
  vapidKey?: string;
  [key: string]: unknown;
}

/**
 * Web push wiring of the host application (ADR-003, plan AD-09). The chat UI never
 * imports an application environment — this token is the only way it learns where the
 * API and the messaging service worker are.
 */
export interface ChatPushConfig {
  /** API base URL (e.g. `https://api.trendmulti.com.br/api`) — the logout cleanup uses it. */
  apiUrl: string;
  firebase: ChatPushFirebaseConfig | null;
  /** Messaging service worker script URL (a static asset of the application). */
  serviceWorkerUrl: string;
  /**
   * Registration scope of that worker. The chat app registers it OUTSIDE `/`, which the
   * Angular service worker owns; the product has no Angular worker and keeps the default.
   */
  serviceWorkerScope?: string;
  /**
   * Show the friendly toast before the browser's permission prompt. Default true. The
   * chat app turns it off: it offers its own explicit call-to-action instead (T-35).
   */
  prePrompt?: boolean;
}

export const CHAT_PUSH_CONFIG = new InjectionToken<ChatPushConfig>('trendmulti_chat_push_config');

/**
 * Opens a work reference (Attendance / CRM Card / Contact) — RF-25. The product navigates
 * in-app; the chat app opens the record in the product, in another tab. Absent = in-app
 * router navigation.
 */
export interface ChatContextRefNavigator {
  open(reference: ChatContextRef): void;
}

export const CHAT_CONTEXT_REF_NAVIGATOR = new InjectionToken<ChatContextRefNavigator>('trendmulti_chat_context_ref_navigator');
